import React, { useEffect, useState } from 'react'
import { Builder, BuilderComponent, builder } from '@builder.io/react'

import '@builder.io/widgets'

// Determine the API key based on the URL
const builderPublicApiKey =
  window?.REACT_ENV_VARIABLES?.BUILDER_PUBLIC_API_KEY ||
  '61e2402350ce4c0cbc02c5526b936de4'

builder.init(builderPublicApiKey)

const SIGNED_OUT_LP_PATH = window?.REACT_ENV_VARIABLES?.BUILDER_SIGNED_OUT_LP_PAGE_PATH || '/signed-out-lp'

const BuilderLP = ({ ...rest }) => {
  const [signedOutLP, setSignedOutLP] = useState(null)

  useEffect(() => {
    builder
      .get('page', {
        userAttributes: {
          urlPath: SIGNED_OUT_LP_PATH
        }
      })
      .toPromise()
      .then((signedOutLPSection) => setSignedOutLP(signedOutLPSection))
  }, [])

  return <BuilderComponent model='page' content={signedOutLP} />
}

export default BuilderLP
